var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLocationOldTown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.058,
    height: 15.058,
    viewBox: "0 0 15.058 15.058",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "location-old-town",
    transform: "translate(-726 -2313)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 7.529,
    cy: 7.529,
    r: 7.529,
    transform: "translate(726 2313)",
    fill: "#6f6f6f"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Icon_map-museum",
    "data-name": "Icon map-museum",
    d: "M2.458,6.541H3.28l.126,3.782H2.348ZM1.77,10.533H9.754v.42h.63v.63h.42V12H.72v-.42h.42v-.63h.63Zm8.4-5.082L5.763,3.6,1.35,5.451V5.7h8.824Zm-7.984.46H9.334v.42H2.191Zm6.037.63H9.05l.128,3.782H8.118Zm-1.923,0h.822l.126,3.782H6.195Zm-1.923,0H5.2l.125,3.782H4.271l.111-3.782Z",
    transform: "translate(728.011 2312.131)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationOldTown);
export default __webpack_public_path__ + "static/media/location-old-town.76777e82e863ff743e3173f82e0169e1.svg";
export { ForwardRef as ReactComponent };